import { render, staticRenderFns } from "./StandardCategorizationContainer.vue?vue&type=template&id=d8bdddd4&"
import script from "./StandardCategorizationContainer.vue?vue&type=script&lang=ts&"
export * from "./StandardCategorizationContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports